Directives.HomeCardDirective = function HomeCardDirective() {

    // @ngInject
    function HomeCardDirectiveControllerFunc($injector, $scope, HomeService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'HomeCardDirectiveController';
        this.HomeService = HomeService;

        this.isHomeForTrialer = this.HomeService.shouldShowHomeForTrialers();
    }

    var HomeCardDirectiveController = Class(Controllers.BaseController, {
        constructor: HomeCardDirectiveControllerFunc,

        onCardClick : function onCardClick($event) {
            if (this.isHomeForTrialer && this.emptyState) {
                this.goToView();
                $event.preventDefault();
                $event.stopPropagation();
            }
        },

        onHeaderClick: function onHeaderClick() {
            this.goToView && this.goToView();
        }
    });

    return {
        scope: {
          type: '@',
          goToView: '&',
          link: '@',
          emptyState: '<',
          loading: '<'
        },
        templateUrl: 'angular/app/modules/core/features/home/home_card/home_card_directive.html',
        controller: HomeCardDirectiveController,
        controllerAs: 'homeCardVm',
        transclude: {
            'shimmer': '?homeCardShimmer'
        },
        bindToController: true
    };
};
